var quantityLabel = "Quantità";
var quantityFlyoutHeader = "Scegli una quantità";
var quantityFlyoutCTA = "Seleziona questa quantità";
var closeButton = "Chiudi";
var pricePlaceholder = "...";
var priceLabel = "Prezzo";
var unitPriceLabel = "Prezzo unitario";
var incompatibilityMessage = "Ora disponibile con altre opzioni selezionate: ";
var select = "Seleziona...";
var percentSavings = "{{{PERCENT}}}% risparmiato";
var sale = "offerta";
var amountSavings = "{{{AMOUNT}}} risparmio / unità";
var amountSavingsWithSale = "{{{AMOUNT}}} risparmio / unità + offerta";
var seeMoreQuantities = "Vedi altre quantità";
var required = "Obbligatorio";
var sample = "Campione";
var estimatedQuantity = "Quantità stimata";
var numberOfRecipients = "{{{COUNT}}} Destinatari";
var recommendedCallout = "Scelta consigliata";
var newCallout = "Novità";
var incompatibleLabel = "Incompatibile";
var outOfStockCallout = "Articolo non disponibile";
var dismissAlert = "Ignora avviso";
var unwindingMessage_1 = "Incompatibile con {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2 = "Incompatibile con {{{ATTRIBUTE1}}} {{{OPTION1}}} e {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3 = "Incompatibile con {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} e {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more = "Incompatibile con più di {{{ATTRIBUTE_COUNT}}} opzioni.";
var unwindingAlertMessage_1 = "Per essere compatibile con {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} è stato deselezionato.";
var unwindingAlertMessage_2 = "Per essere compatibile con {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} e {{{ATTRIBUTE2}}} {{{OPTION2}}} sono stati deselezionati.";
var unwindingAlertMessage_3 = "Per essere compatibile con {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} e {{{ATTRIBUTE3}}} {{{OPTION3}}} sono stati deselezionati.";
var unwindingAlertMessage_more = "Per essere compatibile con {{{ATTRIBUTE}}} {{{OPTION}}}: Sono state deselezionate più di {{{ATTRIBUTE_COUNT}}} opzioni.";
var fullRangedHelperText = "Da {{{MINIMUM}}} {{{UNIT}}} a {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText = "Almeno {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets = "Inserisci un valore tra {{{MINIMUM}}} e {{{MAXIMUM}}} pagine, inclusa la copertina ";
var rangePartialRangedHelperTextForBooklets = "Almeno {{{MINIMUM}}} pagine, inclusa la copertina ";
var rangedGeneralInputError = "Inserimento non valido";
var rangedBetweenRangesError = "I numeri più vicini sono {{{LOWER}}} {{{UNIT}}} e {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError = "Il numero non può avere più di 8 decimali";
var rangedMinInputValueError = "Il numero minimo è {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError = "Il numero massimo è {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError = "Il valore inserito deve essere un numero";
var requiredAttributeFieldError = "Inserisci un valore compreso tra {{{LOWER}}} e {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets = "I numeri più vicini sono {{{LOWER}}} pagine e {{{HIGHER}}} pagine ";
var rangedMinInputValueErrorForBooklets = "Il numero minimo è {{{MINIMUM}}} pagine ";
var rangedMaxInputValueErrorForBooklets = "Il numero massimo è {{{MAXIMUM}}} pagine ";
var requiredAttributeFieldErrorForBooklets = "Inserisci un valore tra {{{LOWER}}} e {{{HIGHER}}} inclusa la copertina ";
var requiredInformationToast = "Inserisci tutte le informazioni necessarie.";
var itIt = {
	quantityLabel: quantityLabel,
	quantityFlyoutHeader: quantityFlyoutHeader,
	quantityFlyoutCTA: quantityFlyoutCTA,
	closeButton: closeButton,
	pricePlaceholder: pricePlaceholder,
	priceLabel: priceLabel,
	unitPriceLabel: unitPriceLabel,
	incompatibilityMessage: incompatibilityMessage,
	select: select,
	percentSavings: percentSavings,
	sale: sale,
	amountSavings: amountSavings,
	amountSavingsWithSale: amountSavingsWithSale,
	seeMoreQuantities: seeMoreQuantities,
	required: required,
	sample: sample,
	estimatedQuantity: estimatedQuantity,
	numberOfRecipients: numberOfRecipients,
	recommendedCallout: recommendedCallout,
	newCallout: newCallout,
	incompatibleLabel: incompatibleLabel,
	outOfStockCallout: outOfStockCallout,
	dismissAlert: dismissAlert,
	unwindingMessage_1: unwindingMessage_1,
	unwindingMessage_2: unwindingMessage_2,
	unwindingMessage_3: unwindingMessage_3,
	unwindingMessage_more: unwindingMessage_more,
	unwindingAlertMessage_1: unwindingAlertMessage_1,
	unwindingAlertMessage_2: unwindingAlertMessage_2,
	unwindingAlertMessage_3: unwindingAlertMessage_3,
	unwindingAlertMessage_more: unwindingAlertMessage_more,
	fullRangedHelperText: fullRangedHelperText,
	rangePartialRangedHelperText: rangePartialRangedHelperText,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets,
	rangedGeneralInputError: rangedGeneralInputError,
	rangedBetweenRangesError: rangedBetweenRangesError,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError,
	rangedMinInputValueError: rangedMinInputValueError,
	rangedMaxInputValueError: rangedMaxInputValueError,
	rangedNotANumberError: rangedNotANumberError,
	requiredAttributeFieldError: requiredAttributeFieldError,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets,
	requiredInformationToast: requiredInformationToast
};

export { amountSavings, amountSavingsWithSale, closeButton, itIt as default, dismissAlert, estimatedQuantity, fullRangedHelperText, fullRangedHelperTextForBooklets, incompatibilityMessage, incompatibleLabel, newCallout, numberOfRecipients, outOfStockCallout, percentSavings, priceLabel, pricePlaceholder, quantityFlyoutCTA, quantityFlyoutHeader, quantityLabel, rangePartialRangedHelperText, rangePartialRangedHelperTextForBooklets, rangedBetweenRangesError, rangedBetweenRangesErrorForBooklets, rangedDecimalPrecisionError, rangedGeneralInputError, rangedMaxInputValueError, rangedMaxInputValueErrorForBooklets, rangedMinInputValueError, rangedMinInputValueErrorForBooklets, rangedNotANumberError, recommendedCallout, required, requiredAttributeFieldError, requiredAttributeFieldErrorForBooklets, requiredInformationToast, sale, sample, seeMoreQuantities, select, unitPriceLabel, unwindingAlertMessage_1, unwindingAlertMessage_2, unwindingAlertMessage_3, unwindingAlertMessage_more, unwindingMessage_1, unwindingMessage_2, unwindingMessage_3, unwindingMessage_more };
//# sourceMappingURL=it-it.json.mjs.map
